var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=js&"
export * from "./TransitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=ec9fad40&scoped=true&lang=css&"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9fad40",
  null
  
)

export default component.exports